module.exports = __webpack_public_path__ + "static/hobgoblin_war_camp-0aaead133a9dd348f05ee0aa86b58435.jpg";